import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';

export const ActionButton = props => {
    const { options, style, userId, advanceStepper } = props;
    let { label = "Next", form = null, primary = true, secondary = false, isNextButton = true, action = () => { return null }, raised = true, disabled = false, backgroundColor = null, labelColor = null } = options;
    if (backgroundColor) {
        primary = false;
        secondary = false;
    }
    const isForm = !!form;
    const formType = (isForm) ? "submit" : "button";

    return (raised)
    ?   <RaisedButton
            label={label}
            type={formType}
            onSubmit={(event)=>{ 
                event.preventDefault();
            }}
            onClick={(event)=>{
                action(event);
                if (isNextButton && !!userId) advanceStepper();
            }}
            form={form}
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            disableTouchRipple={true}
            disableFocusRipple={true}
            primary={primary}
            secondary={secondary}
            style={{marginRight: 0, ...style}}
            disabled={disabled}
        />
    :   <FlatButton
            label={label}
            type={formType}
            onSubmit={(event)=>{ 
                event.preventDefault();
            }}
            onClick={(event)=>{
                if (isNextButton) advanceStepper();
                action(event);
            }}
            form={form}
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            disableTouchRipple={true}
            disableFocusRipple={true}
            primary={primary}
            secondary={secondary}
            style={{ marginRight: 12, ...style}}
            disabled={disabled}
        />
}


// WEBPACK FOOTER //
// ./src/js/components/Form/Buttons/ActionButton.jsx